var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass,style:(_vm.getStyle)},[(_vm.typeAlert)?_c('v-alert',{attrs:{"border":"left","colored-border":"","color":"success","elevation":"2"}},[_vm._t("default")],2):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }